import axios from "axios";

// GET API Hostname
const host = window.location.hostname.split(".");
axios.defaults.baseURL = "https://" + host[0] + ".polixen.com/api";

// Dev
// axios.defaults.baseURL = "http://localhost/api";

let token = localStorage.getItem("token");
if (token !== null) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

const handleApiError = e => {
  const resp = e.response.data;

  if (resp.errors) {
    throw resp.errors;
  } else {
    let errors = ["An Error Occurred"];
    throw errors;
  }
};

const setToken = token => {
  localStorage.setItem("token", token);
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

export { axios, handleApiError, setToken, host };
